import Icon from '../components/Icon.vue'

Icon.register({
  'venus-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V368H76C69.4 368 64 373.4 64 380V420C64 426.6 69.4 432 76 432H112V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V432H212C218.6 432 224 426.6 224 420V380C224 373.4 218.6 368 212 368H176V316.4C240.1 301.9 288 244.5 288 176zM64 176C64 131.9 99.9 96 144 96S224 131.9 224 176 188.1 256 144 256 64 220.1 64 176zM400 316.4V368H436C442.6 368 448 373.4 448 380V420C448 426.6 442.6 432 436 432H400V468C400 474.6 394.6 480 388 480H348C341.4 480 336 474.6 336 468V432H300C293.4 432 288 426.6 288 420V380C288 373.4 293.4 368 300 368H336V316.4C314.8 311.6 295.4 302.1 278.8 289.1 292.8 272.4 303.8 253.1 310.9 232 325.4 246.8 345.6 256 368 256 412.1 256 448 220.1 448 176S412.1 96 368 96C345.7 96 325.4 105.2 310.9 120 303.8 98.9 292.9 79.6 278.8 62.9 303.4 43.6 334.3 32 368 32 447.5 32 512 96.5 512 176 512 244.5 464.1 301.9 400 316.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/venus-double.js
// module id = SRUk
// module chunks = 144